let watermark = {};

let timer = null;

let setWatermark = (str, element) => {
  let id = '1.23452384164.123412415';

  if (!element) {
    return;
  }

  if (document.getElementById(id) !== null) {
    element.removeChild(document.getElementById(id));
  }

  let can = document.createElement('canvas');
  can.width = 400;
  can.height = 300;

  let cans = can.getContext('2d');
  const strArr = str.split(',');
  cans.rotate((-20 * Math.PI) / 180);
  cans.font = '14px Vedana';
  cans.fillStyle = 'rgba(0, 0, 0, 0.1)';
  cans.textAlign = 'center';
  cans.textBaseline = 'Middle';
  strArr.forEach((str, i) => cans.fillText(str, can.width / 2, can.height / 2 + i * 20));

  let div = document.createElement('div');
  div.id = id;
  div.style.pointerEvents = 'none';
  div.style.top = '3px';
  div.style.left = '0px';
  div.style.position = 'absolute';
  div.style.zIndex = '9';
  div.style.width = element.clientWidth + 'px';
  div.style.height = element.scrollHeight + 'px';
  div.style.background = 'url(' + can.toDataURL('image/png') + ') left top repeat';
  element.appendChild(div);
  return id;
};

// 该方法只允许调用一次
watermark.set = (str, element) => {
  let id = setWatermark(str, element);
  timer = setInterval(() => {
    if (document.getElementById(id) === null || document.getElementById(id).clientHeight != element.scrollHeight) {
      id = setWatermark(str, element);
    }
  }, 1000);
  window.onresize = () => {
    setWatermark(str, element);
  };
};

watermark.remove = element => {
  let id = '1.23452384164.123412415';
  clearInterval(timer);
  if (document.getElementById(id) !== null) {
    element.removeChild(document.getElementById(id));
  }
};

export default watermark;
